import { FC, useEffect, useState } from "react";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";
import { Typography } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./CBQuill.scss";

interface CBQuillTypes {
  label?: string;
  name: string;
  control: any;
  disabled?: boolean;
  onChange?: any;
}

const CBQuill: FC<CBQuillTypes> = ({
  label,
  name,
  control,
  disabled = false,
  onChange = () => {},
}) => {
  const { field, fieldState } = useController({ name, control });
  const [value, setValue] = useState(field.value);
  const id = `quill-${field.name}`;
  const { Title } = Typography;

  useEffect(() => {
    setValue(field.value);
  }, [field.value]);

  return (
    <div className="CBQuill">
      {label && <Title level={5}>{label}</Title>}
      <ReactQuill
        id={id}
        theme="snow"
        readOnly={disabled}
        className={fieldState.error ? "quill-error" : ""}
        value={value}
        onChange={(e: any) => {
          setValue(e);
          field.onChange(e);
          onChange(e);
        }}
      />
      {!!fieldState.error && (
        <span role="alert" className="text-red-500">
          {fieldState.error.message}
        </span>
      )}
    </div>
  );
};

CBQuill.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CBQuill;
